<template>
    <el-button @click="file"  size="mini">浏览本地文件夹</el-button>
    <input type="file" style="display: none" name="file1" ref="files" webkitdirectory directory  @change="fileInfo($event)"/>
  <div v-dialogDrag>
    <el-dialog
            v-model="dialogVisible"
            title="测井曲线文件选择"
            width="500px"
            destroy-on-close
            :close-on-click-modal="false"
    >
        <el-scrollbar height="200px" native v-loading="loading">
            <el-space wrap>
                <el-checkbox-group v-model="fileCheck" v-if="show" @change="lengthLimit">
                    <ul>
                        <li v-for="item in fileList" :key="item.index">
                            <el-checkbox :disabled="item.isUpload"  :label="item.index">
                                <div style="width:350px">
                                    {{item.name}}
                                    <span v-show="item.isUpload" style="color:red;float:right">√</span>
                                </div>
                            </el-checkbox>
                        </li>
                    </ul>
                </el-checkbox-group>
            </el-space>
        </el-scrollbar>
        <template #footer>
            <span class="dialog-footer">
                <el-button :disabled="loading" @click="wellRemove">取消</el-button>
                <el-button :disabled="loading" type="primary" @click="wellOk">上传</el-button>
            </span>
        </template>
    </el-dialog>
  </div>
</template>
<script>
  import {ElMessage} from "element-plus";
  import axios from "axios";
  export default {
    name: "las-upload-view",
    data(){
      return{
        fileList:[],//本地文件夹
        dialogVisible:false,//文件选择
        show:true,
        loading:false,
        fileCheck:[],//选中的文件列表
        fileUploadIndex:0,//上传文件的次数
        uploadList:[],//上传列表
      }
    },
    methods:{
      file(){
        this.$refs.files.click();
      },
      fileInfo(){
        this.fileList = this.$refs.files.files
        console.log(this.fileList)
        if(this.fileList.length != 0){
          this.fileList.forEach((item,index)=>{
            //console.log(item.name.split(".")[1])
            item.fileType = item.name.split(".")[1]
            item.index = index
            item.isUpload = false
          })
          console.log(this.fileList)

        }else{
          ElMessage("您选择的文件夹为空")
          return
        }
        this.dialogVisible = true
        //this.typeChoose()
      },
      lengthLimit(){
        if(this.fileCheck.length >=10){
          this.fileCheck.pop()
          ElMessage("单次上传数量不得超过10个")
          return
        }
      },
      wellOk(){
        if(this.fileCheck.length == 0){
          ElMessage("请勾选数据后再提交")
          return
        }
        this.fileUploadCheck(this.fileUploadIndex)
      },
      wellRemove(){
        this.$refs.files.value = "";
        this.dialogVisible = false;
        this.fileList = [];
        this.fileCheck = [];
        this.uploadList = [];
        this.fileUploadIndex = 0;

      },
      //文件上传检查
      fileUploadCheck(index){
        if(this.fileUploadIndex == this.fileCheck.length){
          this.fileUpload()
        }else{
          this.fileUploadBase(index)
        }
      },
      //文件上传转base64
      fileUploadBase(index){
        // console.log(index)
        let fileIndex = this.fileCheck[index]
        //console.log(fileIndex)
        //console.log(this.fileList[fileIndex])
        // let type = this.fileList[fileIndex].fileType;
        let name = this.fileList[fileIndex].name;
        let reader = new FileReader();
        reader.readAsDataURL(this.fileList[fileIndex])
        reader.onload = (event) =>{
          let base64 = event.target.result;
          //console.log(base64)
          this.uploadList.push({
            file_Base64:base64,
            data:name
          })
          this.fileUploadIndex++
          this.fileUploadCheck(this.fileUploadIndex)
          //this.fileUpload(index,base64,type,name)
        }
      },
      //文件上传
      fileUpload(){
        this.loading = true
        let token = localStorage.getItem("lyqtJwt");
        let data = {
          type:"las",
          authorization:token,
          lasFiles:this.uploadList
        }
        console.log(this.fileList)
        console.log(data)
        let uploadUrl = process.env.VUE_APP_SERVER +`/fileprocesser/upload/analysis`
        axios.post(uploadUrl,data)
          .then(res=>{
            console.log(res)
            this.fileCheck.forEach(item=>{
              this.fileList[item].isUpload = true
            })
            this.show = false
            this.$nextTick(()=>{
              this.show = true
              this.fileCheck = []
              this.loading = false
              ElMessage("添加成功")
            })
          })
      }
    }
  }
</script>

<style scoped>

</style>